/**
 * WhatsApp Utility for Money Vision forms
 * Phone: +91 7506550715 (917506550715)
 */

export const sendFormData = (formData, formType) => {
  const phone = '917506550715';
  
  // Handle varying phone keys across forms
  const userPhone = formData.phone || formData.mobile || formData.number || 'N/A';
  
  const message = `🚀 New *${formType}* Lead:

👤 *Name:* ${formData.name || 'N/A'}
📱 *Phone:* ${userPhone}
✉️ *Email:* ${formData.email || 'N/A'}

${formData.message || formData.borrowAmount || formData.monthlySalary || formData.serviceType || formData.type ? `

📝 *Details:* 
${formData.type ? `Partner Type: ${formData.type}` : ''}
${formData.message ? `Message: ${formData.message}` : ''}
${formData.borrowAmount ? `Borrow Amount: ₹${formData.borrowAmount}` : ''}
${formData.monthlySalary ? `Monthly Salary: ₹${formData.monthlySalary}` : ''}
${formData.serviceType ? `Service: ${formData.serviceType}` : ''}
` : ''}`;

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  
  // Open in new tab/window
  window.open(whatsappUrl, '_blank');
  
  // Optional: return promise-like for loading
  return new Promise((resolve) => setTimeout(resolve, 1000));
};

